<svg viewBox="0 0 24 24" 
    xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M19.416 18.709a9.96 9.96 0 0 0 2.572-6.209h-8.78l6.208 6.209zm-.707.707L11.5 12.207V2.012C6.21 2.272 2 6.645 2 12c0 5.523 4.477 10 10 10a9.963 9.963 0 0 0 6.709-2.584zM12.5 2.012V11.5h9.488A10 10 0 0 0 12.5 2.012zM12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12z"/>
</svg>
